import { getCountryFromCode, getUserCountryByLanguage } from 'utils/location';
import {
  CREATE_ACCOUNT_REQUEST,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  SET_COUNTRY_REQUEST,
  SET_COUNTRY_BY_LOCATION_API,
  SET_COUNTRY_FAILURE,
  SET_EULA_LINK,
  SET_PRIVACY_POLICY,
  SET_EULA_LINK_SUCCESS,
  SET_EULA_LINK_FAILURE,
  SET_REGISTRATION_EMAIL,
  SET_EMAIL_ERROR_TEXT,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_MISSING_ERROR_TEXT,
  SET_REGISTRATION_PASSWORD,
  SET_PASSWORD_ERROR_TEXT,
  SET_PHONE_NUMBER_ERROR_TEXT,
  SET_PHONE_NUMBER,
  TOGGLE_EULA_ACCEPTANCE,
  TOGGLE_SHOW_PASSWORD
} from 'constants/actionTypes';

export function createAccount() {
  return {
    type: CREATE_ACCOUNT_REQUEST
  };
}

export function createAccountSuccess(user) {
  return {
    type: CREATE_ACCOUNT_SUCCESS,
    user
  };
}

export function createAccountFailure(apiErrorText) {
  return {
    type: CREATE_ACCOUNT_FAILURE,
    apiErrorText
  };
}

export function determineUserCountryByLanguage() {
  const { country, countryId } = getUserCountryByLanguage();
  return {
    type: SET_COUNTRY_REQUEST,
    country,
    countryId
  };
}

export function determineUserCountryByCountryCode(countryCode) {
  const { country, countryId } = getCountryFromCode(countryCode);
  return {
    type: SET_COUNTRY_REQUEST,
    country,
    countryId
  };
}

export function determineUserCountryByLocation(coordinates) {
  return {
    type: SET_COUNTRY_BY_LOCATION_API,
    coordinates
  };
}

export function setCountry(country, countryId) {
  let countryName = country || getCountryFromCode(countryId).country;

  return {
    type: SET_COUNTRY_REQUEST,
    country: countryName,
    countryId
  };
}

export function setCountryFailure(error) {
  return {
    type: SET_COUNTRY_FAILURE,
    error
  };
}

export function setEulaLink(response) {
  return {
    type: SET_EULA_LINK,
    eulaLink: response.pdfContentUrl,
    documentId: response.id
  };
}

export function setPrivacyPolicy(response) {
  return {
    type: SET_PRIVACY_POLICY,
    ppLink: response.pdfContentUrl,
    documentId: response.id
  };
}

export function setEulaLinkSuccess() {
  return {
    type: SET_EULA_LINK_SUCCESS
  };
}

export function setEulaLinkFailure(error) {
  return {
    type: SET_EULA_LINK_FAILURE,
    error
  };
}

export function setEmail(value) {
  return {
    type: SET_REGISTRATION_EMAIL,
    value
  };
}

export function setEmailErrorText(emailErrorText) {
  return {
    type: SET_EMAIL_ERROR_TEXT,
    emailErrorText
  };
}

export function setFirstName(value) {
  return {
    type: SET_FIRST_NAME,
    value
  };
}

export function setLastName(value) {
  return {
    type: SET_LAST_NAME,
    value
  };
}

export function setMissingErrorText(missingInputsList) {
  return {
    type: SET_MISSING_ERROR_TEXT,
    missingInputsList
  };
}

export function setPassword(value) {
  return {
    type: SET_REGISTRATION_PASSWORD,
    value
  };
}

export function setPasswordErrorText(passwordErrorText) {
  return {
    type: SET_PASSWORD_ERROR_TEXT,
    passwordErrorText
  };
}

export function setPhoneNumberErrorText(phoneNumberErrorText) {
  return {
    type: SET_PHONE_NUMBER_ERROR_TEXT,
    phoneNumberErrorText
  };
}

export function setPhoneNumber(value) {
  return {
    type: SET_PHONE_NUMBER,
    value
  };
}

export function toggleEulaAcceptance() {
  return {
    type: TOGGLE_EULA_ACCEPTANCE
  };
}

export function toggleShowPassword() {
  return {
    type: TOGGLE_SHOW_PASSWORD
  };
}